const keys = (t) => [
    {
        key: 'impressions',
        label: t('discover.overview.page_performance.impressions'),
        format: '0,00a',
    },
    {
        key: 'clicks',
        label: t('discover.overview.page_performance.clicks'),
        format: '0,00a',
        yAxisID: 'y1',
    },
];

export default keys;
